import React from 'react';
import Dashboard from '../components/dashboard/Dashboard';

const DashboardPage: React.FC = () => {
  return <Dashboard />;
};

export default DashboardPage;
